import { useState, useCallback } from 'react'
import { ModalBody, Button } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import SubHeading from 'e-submission/components/Heading/SubHeading'
import ExpandableDuplicateField from './ExpandableDuplicateField'
import ResendLinkSection from './ResendLinkSection'
import { InfoTooltip } from './InfoTooltip'
import { SpanTextSize } from 'common-components/text'

import { getCurrentApp } from '../../../apps/selectors'
import { getCitizenId, getPassport } from 'e-submission/domain/data-model/form/selectors'
import {
  createCaseEkyc,
  createCaseEkycFromDevice,
  removeError,
  reuseCaseEkyc,
  setReuseEkycSelected,
} from '../../../apps/actions'
import { getIcon } from 'e-submission/components/Icon'
import { Modal } from 'common-components/index'
import styled from 'styled-components'
import { deviceType } from '../../../domain/data-model/form/utils'

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Footer = styled.div`
  display: flex;
  padding-top: 1rem;
  justify-content: center;
`

const MarginRigthBtn = styled(Button)`
  margin-right: 1rem;
`

const SubmitButton = (props) => {
  const { onExit, handlerConfirm } = props

  return (
    <Footer>
      <MarginRigthBtn outline color="primary" onClick={() => onExit()}>
        ยกเลิก
      </MarginRigthBtn>
      <Button color="primary" onClick={() => handlerConfirm()}>
        ยืนยัน
      </Button>
    </Footer>
  )
}

export const DuplicateEkycCaseModal = ({
  isOpen,
  duplicateCase,
  seletedOption,
  setOption,
  handleOnExistDuplicateModal,
  handlerConfirm,
  isEnableEkycOnDevice,
  closeIdentifyRespondingModal,
}) => {
  return (
    <Modal
      className={'duplicate-ekyc-modal'}
      isOpen={isOpen}
      size="md"
      modalClassName="default-bootstrap remote-selling-modal"
      toggle={() => {
        handleOnExistDuplicateModal()
      }}
    >
      <ModalBody className="form-group">
        <TitleSection>
          {getIcon('copy')}
          <SubHeading>แจ้งเตือนเคส eKYC</SubHeading>
          เราตรวจเจอเคสที่ซ้ำกันที่จำเป็นต้องชี้แจง
        </TitleSection>
        <ExpandableDuplicateField cases={duplicateCase} seletedOption={seletedOption} setOption={setOption} />
        <InfoTooltip>
          {deviceType() === 'mobile' || !isEnableEkycOnDevice ? null : (
            <div>
              <SpanTextSize>สร้างใหม่:</SpanTextSize> สร้างเป็นเคสใหม่และส่งลิงก์เพื่อยืนยันตัวตนใหม่
              <br />
              <SpanTextSize>ใช้ซ้ำ:</SpanTextSize> สร้างแถวใหม่ขึ้นมาในแดชบอร์ดแต่ใช้ผลลัพธ์ยืนยันตัวตนจากเคสก่อน
            </div>
          )}
          <SpanTextSize>*โปรดตรวจสอบวันหมดอายุของเอกสารทุกครั้ง</SpanTextSize>
        </InfoTooltip>
        {seletedOption === 'new-case' && !isEnableEkycOnDevice && <ResendLinkSection />}
        {/* new resend link to confiamation letter */}
        <SubmitButton onExit={handleOnExistDuplicateModal} handlerConfirm={handlerConfirm} />
      </ModalBody>
    </Modal>
  )
}

const mapStateToProps = (state, props) => {
  const app = getCurrentApp(state)

  const insuredId = getCitizenId('insured')(app)
  const payerId = getCitizenId('payer')(app)
  const insuredPassport = getPassport('insured')(app)
  const payerPassport = getPassport('payer')(app)
  return {
    citizenId: { insured: insuredId, payer: payerId },
    passportNumber: { insured: insuredPassport, payer: payerPassport },
  }
}

const DuplicateEkycCaseContainer = ({
  isOpen,
  duplicateCase,
  insuredOrPayer,
  onExit,
  openIdentifyRespondingModal,
  closeIdentifyRespondingModal,
  isEnableEkycOnDevice,
}) => {
  const dispatch = useDispatch()
  const { citizenId, passportNumber } = useSelector(mapStateToProps)

  const [seletedOption, setOption] = useState('new-case')

  const createCase = useCallback(
    (id, passportNumber) => dispatch(createCaseEkyc(insuredOrPayer, id, passportNumber, true)),
    [dispatch, insuredOrPayer]
  )

  const createCaseFromDevice = useCallback(
    (id, passportNumber, openRespondModalOnFailedCase) => {
      dispatch(createCaseEkycFromDevice(insuredOrPayer, id, passportNumber, openRespondModalOnFailedCase, true))
    },
    [dispatch, insuredOrPayer]
  )

  const reuseCaseEkycHandler = useCallback((proprietorId) => dispatch(reuseCaseEkyc(insuredOrPayer, proprietorId)), [
    dispatch,
    insuredOrPayer,
  ])

  const handleOnExistDuplicateModal = useCallback(() => {
    closeIdentifyRespondingModal()
    onExit()
    dispatch(removeError('EKYC_DUPLICATED_CITIZENID'))
  }, [dispatch, onExit])

  const setReuseEkycSelectedHandler = useCallback((value) => dispatch(setReuseEkycSelected(value)), [dispatch])

  const handlerConfirm = useCallback(() => {
    handleOnExistDuplicateModal()
    if (seletedOption === 'new-case') {
      if (isEnableEkycOnDevice) {
        // eslint-disable-next-line no-inner-declarations
        function openRespondModalOnFailedCase() {
          openIdentifyRespondingModal()
        }
        createCaseFromDevice(citizenId[insuredOrPayer], passportNumber[insuredOrPayer], openRespondModalOnFailedCase)
        return
      } else {
        createCase(citizenId[insuredOrPayer], passportNumber[insuredOrPayer])
      }
    }

    if (seletedOption === 'reuse') {
      const reuseProprietorId = duplicateCase[0].id
      reuseCaseEkycHandler(reuseProprietorId)
      setReuseEkycSelectedHandler(true)
    } else {
      setReuseEkycSelectedHandler(false)
    }

    openIdentifyRespondingModal()
  }, [
    seletedOption,
    isEnableEkycOnDevice,
    citizenId,
    insuredOrPayer,
    duplicateCase,
    createCaseFromDevice,
    createCase,
    reuseCaseEkycHandler,
    setReuseEkycSelectedHandler,
    openIdentifyRespondingModal,
    handleOnExistDuplicateModal,
  ])

  return (
    <DuplicateEkycCaseModal
      isOpen={isOpen}
      duplicateCase={duplicateCase}
      seletedOption={seletedOption}
      setOption={setOption}
      handleOnExistDuplicateModal={handleOnExistDuplicateModal}
      handlerConfirm={handlerConfirm}
      isEnableEkycOnDevice={isEnableEkycOnDevice}
    />
  )
}

export default DuplicateEkycCaseContainer
